/* --------------------------------------------------------------------------------------
   folderChangeAlert.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const folderChangeAlertComponent = {
  template: `
    <div xw-alert display="vm.display" on-accepted="vm.accept()" on-close="vm.cancel()" cancel-continue-buttons>
      <p translate>CHANGING_FOLDERS_DESELECT</p>
    </div>
  `,
  bindings: {
    display: '=',
    onAccepted: '&'
  },
  controllerAs: 'vm',
  controller: class folderChangeAlertCtrl {
    /* @ngInject */
    constructor(commonService) {
      this.commonService = commonService
    }
    accept() {
      this.display = false
      this.commonService.updateView()
      this.onAccepted()
    }
    cancel() {
      this.display = false
      this.commonService.updateView()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/browser/components/folderChangeAlert.component.js